<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="LIST OF ABBREVIATIONS FOR FREQUENTLY CITED SOURCES">
<p class="h2" id="abb"><a href="#/text/9780253039767_Contents#rabb"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi"><b>ABBREVIATIONS FOR FREQUENTLY CITED SOURCES</b></span></a></p>
<table class="table">
<tbody><tr>
<td class="td" style="width:30%"><p class="tab"><i>Werke</i></p></td>
<td class="td" style="width:70%"><p class="tab">Hermann Cohen, <i>Hermann Cohens Werke</i>, ed. H. Holzhey, 17 vols. (New York: G. Olms, 1978–).</p></td>
</tr>
<tr>
<td class="td"><p class="tab"><i>KS</i> 1–6</p></td>
<td class="td"><p class="tab">Hermann Cohen, <i>Hermann Cohens Werke</i>, <i>Kleinere Schriften</i>, vols. 12–17 of <i>Werke</i>, 6 vols.</p></td>
</tr>
<tr>
<td class="td"><p class="tab"><i>KBE</i></p></td>
<td class="td"><p class="tab">Hermann Cohen, <i>Kants Begrundung der Ethik</i> (Berlin: F. Dümmler, 1877; repr. in <i>Werke</i> 2).</p></td>
</tr>
<tr>
<td class="td"><p class="tab"><i>LrE</i></p></td>
<td class="td"><p class="tab">Hermann Cohen, <i>System der Philosophie, Erster Teil: Logik der reinen Erkenntnis</i> (Berlin: Bruno Cassirer, 1902; repr. in <i>Werke</i> 6).</p></td>
</tr>
<tr>
<td class="td"><p class="tab"><i>ErW</i></p></td>
<td class="td"><p class="tab">Hermann Cohen, <i>System der Philosophie, Zweiter Teil: Ethik des reinen Willens</i> (Berlin: Bruno Cassirer, 1904; repr. in <i>Werke</i> 7).</p></td>
</tr>
<tr>
<td class="td"><p class="tab"><i>JS</i> 1–3</p></td>
<td class="td"><p class="tab">Hermann Cohen, <i>Hermann Cohens Jüdischen Schriften</i>, vols. 1–3, ed. Bruno Strauss with an introduction by Franz Rosenzweig (Berlin: C. A. Schwetschke &amp; Sohn/Verlagsbuchhandlung, 1924).</p></td>
</tr>
<tr>
<td class="td"><p class="tab"><i>RoR</i></p></td>
<td class="td"><p class="tab">Hermann Cohen, <i>Religion of Reason: Out of the Sources of Judaism</i>, trans. Simon Kaplan (Atlanta, GA: Scholars’ Press, 1995).</p></td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253039767_Abbreviations.vue?431adddb